module.exports = __webpack_public_path__ + "img/resource-nav-phone.2d3f9346.svg";